import React from "react";
import connect from "../../../../icons/connect.svg";
import rainbow from "../../../../icons/rainbow.svg";
import walletConnect from "../../../../icons/wallet-connect.svg";
import crypto from "../../../../icons/crypto.svg";
export default function IconSwapper({
  height,
  width
}: {
  readonly height?: string;
  readonly width?: string;
}): JSX.Element {
  // for some reason these types come out wrong
  const connectCasted: string = (connect as any).src || connect;
  const rainbowCasted: string = (rainbow as any).src || rainbow;
  const walletConnectCasted: string = (walletConnect as any).src || walletConnect;
  const cryptoCasted: string = (crypto as any).src || crypto;
  return <div className="animator-image">
            <img src={connectCasted} height={height} width={width} />
            <img src={walletConnectCasted} height={height} width={width} />
            <img src={rainbowCasted} height={height} width={width} />
            <img src={cryptoCasted} height={height} width={width} />
        </div>;
}